var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3393 9.32001L6.33928 2.32001C5.20731 1.75662 3.84362 1.96344 2.92961 2.83713C2.0156 3.71082 1.7475 5.06379 2.25928 6.22001L4.65928 11.59C4.76928 11.8523 4.76928 12.1477 4.65928 12.41L2.25928 17.78C1.84623 18.7079 1.93074 19.7818 2.48386 20.6337C3.03698 21.4856 3.98358 21.9998 4.99928 22C5.46751 21.9953 5.92877 21.886 6.34928 21.68L20.3493 14.68C21.362 14.1705 22.0011 13.1337 22.0011 12C22.0011 10.8663 21.362 9.82948 20.3493 9.32001H20.3393ZM19.4493 12.89L5.44928 19.89C5.0728 20.0708 4.62362 19.9986 4.32279 19.7089C4.02196 19.4192 3.93284 18.973 4.09928 18.59L6.48928 13.22C6.52022 13.1483 6.54693 13.0748 6.56928 13H13.4593C14.0116 13 14.4593 12.5523 14.4593 12C14.4593 11.4477 14.0116 11 13.4593 11H6.56928C6.54693 10.9252 6.52022 10.8517 6.48928 10.78L4.09928 5.41001C3.93284 5.02698 4.02196 4.58085 4.32279 4.29116C4.62362 4.00147 5.0728 3.92924 5.44928 4.11001L19.4493 11.11C19.7832 11.2811 19.9933 11.6248 19.9933 12C19.9933 12.3753 19.7832 12.7189 19.4493 12.89Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default ForwardRef;